<template>
  <div id="match-result-detail">
    <div class="top-grad"></div>
    <div class="detail-stat">
      <div class="user-ind-me init-pos" v-bind:class="['area' + (getRoleItem(myItem) + 1)]">
        <div class="indicator">{{ myInit }}</div>
        <div class="arrow"><i class="fas fa-long-arrow-alt-down"></i></div>
      </div>
      <div class="bar"></div>
      <div class="user-ind-you init-pos" v-bind:class="['area' + (getRoleItem(yourItem) + 1)]">
        <div class="arrow"><i class="fas fa-long-arrow-alt-up"></i></div>
        <div class="indicator">{{ yourInit }}</div>
      </div>
    </div>

    <div class="detail-text">
      {{ matchDetail }}
    </div>

    <div class="type mine">
      <div class="indicator-container">
        <div class="indicator mine">{{ myInit }}</div>
      </div>
      <div class="title">
        <span class="name">{{ myName }}</span>
        <span class="type">{{ myType }}</span>
      </div>
    </div>
    <div class="detail-text">
      {{ myTypeDetail }}
    </div>

    <div class="type yours">
      <div class="indicator-container">
        <div class="indicator yours">{{ yourInit }}</div>
      </div>
      <div class="title">
        <span class="name">{{ yourName }}</span>
        <span class="type">{{ yourType }}</span>
      </div>
    </div>
    <div class="detail-text">
      {{ yourTypeDetail }}
    </div>

  </div>
</template>

<script>
import common from '@/utils/common';

export default {
  name: 'match-result-detail',
  mixins: [
    common,
  ],
  props: {

    myInit: String,
    myName: String,
    myType: String,
    myItem: Number,

    yourInit: String,
    yourName: String,
    yourType: String,
    yourItem: Number,

    matchDetail: String,
    myTypeDetail: String,
    yourTypeDetail: String,

  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss" src="../scss/match-result-detail.scss"></style>



// WEBPACK FOOTER //
// src/components/MatchResultDetail.vue